module.exports = __webpack_public_path__ + "static/media/2.46da7214.jpg";